import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";

export type OrganisationOption = {
  _id: string;
  title: string;
};

type OrganisationsResponse = {
  data: OrganisationOption[];
};

export const fetchOrganisations = async (): Promise<OrganisationOption[]> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const response = await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/venue-groups?fields=title`,
    {
      cache: "no-store",
      method: "GET",
      headers: {
        "cache-control": "no-store",
        Authorization: `Bearer ${token}`,
        source: "admin"
      }
    }
  );

  if (!response.ok) {
    await throwApiError(response, "Error fetching organisations");
  }

  const responseData: OrganisationsResponse = await response.json();
  return responseData.data || [];
};

export const fetchOrganisationById = async (organisationId: string) => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venue-groups/${organisationId}?extend_users=false&extend_venues=false`,
      {
        cache: "no-store",
        method: "GET",
        headers: {
          "cache-control": "no-store",
          Authorization: `Bearer ${token}`,
          source: "admin"
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching organisation config");
    }

    const responseData = (await response.json()).payload;
    return responseData;
  } catch (error) {
    errorHandler(error, "Error fetching organisation config");
    return null;
  }
};
